import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=48eb812e"
import script from "./cart.vue?vue&type=script&lang=js"
export * from "./cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports